import { AssetsPage } from 'features/assets';

export const OperatorAssetsPage: React.FC = () => <AssetsPage />;
